import type { PiniaColadaOptions } from '@pinia/colada';
import { PiniaColadaCachePersister } from '@pinia/colada-plugin-cache-persister';
import { get, set } from 'idb-keyval';

export default {
  plugins: import.meta.env.VITEST
    ? []
    : [
        PiniaColadaCachePersister({
          storage: {
            getItem: (key) => get<string>(key).then((value) => value ?? null),
            setItem: (key, value) => set(key, value),
          },
        }),
      ],
} satisfies PiniaColadaOptions;
